export default {
  blackList: ["android.widget.AbsListView"],
  mpIdNameCount: {},
  originPanelDatas: {},
  isKindOfClass: function(panel, className) {
    for (var i = 0; i < panel.classes.length; i++) {
      for (var j = 0; j < className.length; j++) {
        if (panel.classes[i] == className[j]) {
          return true;
        }
      }
    }
    return false;
  },
  /*选择同类元素以及参数本身*/
  choosePanels: function(panel) {
    if (!panel) return [];
    var chooseArray = [panel],
      chooseMap = {};
    chooseMap[panel.hashCode] = true;
    /*tabWidget时，不选取同类元素*/
    if (this.isKindOfClass(panel.parent, ["android.widget.TabWidget"])) {
      return chooseArray;
    }
    for (var i = 0; i < panel.childViews.length; i++) {
      var item = panel.childViews[i];
      if (
        this.mpIdNameCount[item.mp_id_name] &&
        this.mpIdNameCount[item.mp_id_name].length > 1
      ) {
        //将所有该mpIdName的panel的父级选中
        for (var j = 0; j < this.mpIdNameCount[item.mp_id_name].length; j++) {
          var parentPanel = this.mpIdNameCount[item.mp_id_name][j].parent;
          if (chooseMap[parentPanel.hashCode] || !this.isClickable(parentPanel))
            continue;
          chooseMap[parentPanel.hashCode] = true;
          chooseArray.push(parentPanel);
        }
      }
    }
    if (this.isKindOfClass(panel.parent, this.blackList)) {
      for (var i = 0; i < panel.parent.childViews.length; i++) {
        var childView = panel.parent.childViews[i];
        if (chooseMap[childView.hashCode] || !this.isClickable(childView))
          continue;
        chooseMap[childView.hashCode] = true;
        chooseArray.push(childView);
      }
    }
    return chooseArray;
  },
  indexOfParent: function(panel) {
    var index = 0;
    for (var i = 0; panel.parent && i < panel.parent.childViews.length; i++) {
      var child = panel.parent.childViews[i];
      if (child == panel) break;
      if (panel.classes[0] == child.classes[0]) index++;
    }
    return index;
  },
  /*为选中的元素添加选中样式*/
  addChoosedStyle: function(orderIndex, eventName) {
    var list = this.choosePanels(this.originPanelDatas[orderIndex]);
    for (var i = 0; i < list.length; i++) {
      $("#" + list[i].orderIndex)
        .addClass("eventVisualizer_panelChecked")
        .attr("title", eventName ? eventName : "");
    }
    lex.log("事件关联元素", list, this.originPanelDatas);
    return list;
  },
  removeChoosedStyle: function(orderIndex) {
    var list = this.choosePanels(this.originPanelDatas[orderIndex]);
    for (var i = 0; i < list.length; i++) {
      $("#" + list[i].orderIndex).removeClass("eventVisualizer_panelChecked");
    }
    return list;
  },
  isClickable: function(panel) {
    var dont_require_clicks = ["android.widget.EditText"];

    var dont_require_identity = [
      "android.widget.Spinner",
      "android.widget.Button",
      // "android.widget.TextView",
      "android.view.View"
    ];
    var is_visible = panel.visibility === 0 && panel.width > 0 && panel.height > 0;

    var is_important = panel.importantForAccessibility;

    var is_clickable = panel.clickable;
    var no_clickable_required = this.isKindOfClass(panel, dont_require_clicks);
    no_clickable_required =
      no_clickable_required || this.is_android_collection_view(panel);
    var isBlack = this.isKindOfClass(panel, this.blackList);

    var is_identified =
      panel.mp_id_name || panel.contentDescription || panel.tag;

    var no_identity_required = this.isKindOfClass(panel, dont_require_identity);
    no_identity_required =
      no_identity_required || this.is_android_collection_view(panel);

    return (
      is_visible &&
      is_important &&
      (is_clickable || no_clickable_required) &&
      (is_identified || no_identity_required) &&
      !isBlack
    );
  },
  is_android_collection_view: function(panel) {
    var list_classes = [
      "android.widget.AbsListView",
      "android.widget.TabWidget"
    ];
    return this.isKindOfClass(panel.parent, list_classes);
  },
  getPosition(
    element,
    position = {
      top: 0,
      left: 0
    }
  ) {
    position.top += element.top;
    position.left += (element.left - element.scrollX);
    if (element.parent) {
      this.getPosition(element.parent, position)
    }
    return position
  }
};
